import apiClient from '@/api/apiClient.js';

export default {
  namespaced: true,
  state: {
    schema: {},
    status: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    status(state) {
      return state.status;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    sendSuccess(state) {
      state.status = 'success';
    },
    sendError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.patOTPSchema();
        const schema = res.data;
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
  },
};
